/* eslint-disable @typescript-eslint/no-explicit-any */
import { api } from "./apiBaseQuery";

export const zeroWeekDiscountService: any = api.injectEndpoints({
  //   reducerPath: "zeroWeekDiscountService",
  //   baseQuery: fetchBaseQuery({
  //     baseUrl: process.env.REACT_APP_BASEURL,
  //     prepareHeaders: (headers) => {
  //       const token = localStorage?.getItem("token");
  //       if (token) {
  //         headers.set("authorization", `Bearer ${token}`);
  //       }
  //       return headers;
  //     },
  //   }),
  endpoints: (builder) => ({
    getZeroWeekDiscounts: builder.query({
      query: () => ({
        url: "Becas/DescuentosSemanaCero",
        method: "GET",
      }),
    }),
    insertZeroWeekDiscount: builder.mutation({
      query: (body) => ({
        url: "Becas/DescuentoSemanaCeroInsert",
        method: "POST",
        body,
      }),
    }),
    updateZeroWeekDiscount: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `Becas/DescuentoSemanaCeroUpdate?id=${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteZeroWeekDiscount: builder.mutation({
      query: (id) => ({
        url: `Becas/DescuentoSemanaCeroDelete?id=${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetZeroWeekDiscountsQuery,
  useInsertZeroWeekDiscountMutation,
  useUpdateZeroWeekDiscountMutation,
  useDeleteZeroWeekDiscountMutation,
} = zeroWeekDiscountService;
